'use client'

import { createContext, useContext, useMemo, type ReactNode } from 'react'

export interface HeaderNavigationContextType {
  trigger: 'hover' | 'click'
}

export const HeaderNavigationContext = createContext<HeaderNavigationContextType>({ trigger: 'hover' })

export interface HeaderNavigationProviderProps extends Partial<HeaderNavigationContextType> {
  children: ReactNode
}

export const HeaderNavigationProvider = ({ trigger = 'hover', children }: HeaderNavigationProviderProps) => {
  const value = useMemo(() => ({ trigger }), [trigger])

  return <HeaderNavigationContext.Provider value={value}>{children}</HeaderNavigationContext.Provider>
}

export const useHeaderNavigationItem = () => useContext(HeaderNavigationContext)
